enum MissionEndStatus {
  FAILED = 'FAILED',
  WARNING = 'WARNING',
  SUCCEEDED = 'SUCCEEDED',
  SUCCEEDED_WITH_ERROR = 'SUCCEEDED_WITH_ERROR',
}

export default MissionEndStatus;
